import { Component } from "@angular/core";
import LocalizationConstants from "src/app/constants/localization-constants";
import { Department } from "src/app/models/Department";
import { DepartmentFilterType } from "src/app/models/DepartmentFilterType";
import { AuthService } from "src/app/services/auth.service";
import { CompanyService } from "src/app/services/company.service";
import { StorageService } from "src/app/services/storage.service";

@Component({
  selector: "dept-select",
  templateUrl: "./dept-select.component.html",
  styleUrls: ["./dept-select.component.scss"],
  standalone: false,
})
export class DeptSelectComponent {
  localizationConstants = LocalizationConstants;
  departmentFilterType = DepartmentFilterType;

  constructor(
    public companyService: CompanyService,
    public storage: StorageService,
    public authService: AuthService,
  ) {}

  onDepartmentSelectionChange(department: Department) {
    this.companyService.onDepartmentSelectionChange(department);
  }
}
